import { z } from 'zod';
import { PlatformSchema } from './platform.js';

export const LiveSummarySchema = z.object({
  platform: PlatformSchema,
  liveChatId: z.string().min(1),
  login: z.string().min(1),
  displayName: z.string().min(1),
  title: z.string(),
  gameName: z.string().nullable(),
  viewerCount: z.number().int().nonnegative(),
  thumbnailUrl: z.string().url(),
  startedAt: z.number().int().nonnegative(),
  // #144: id do vídeo da origem, quando aplicável. YouTube preenche com o videoId
  // resolvido — é o que permite o front re-resolver (/youtube/resolve?videoId=X)
  // pra atualizar o viewerCount de uma live anexada. Twitch não usa. Opcional pra
  // manter o contrato backward-compatible.
  videoId: z.string().optional(),
});
export type LiveSummary = z.infer<typeof LiveSummarySchema>;
